import React, { useState } from "react";
import { HiOutlineChevronDown, HiOutlineChevronUp } from "react-icons/hi";

export default function IdleHistory({ data }) {
  const titles = [
    "SEQ",
    "CLIENT NAME",
    "CONTRACT TYPE",
    "BASIC SALARY",
    "TOTAL SALARY",
    "MOB. DATE",
    "DEMOB. DATE",
    "IDLE DAYS",
    "TOTAL",
    "NO. DAYS",
    "REMARKS",
  ];

  // State to manage collapsible section visibility
  const [isCollapsed, setIsCollapsed] = useState(true);

  // Function to toggle the collapsible section
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  console.log("Idle History data:", data);

  // Use idle history from API response
  const idleHistory = data?.idleHistory || [];

  console.log("Idle history from API:", idleHistory);

  function getDaysBetweenDates(date1, date2) {
    const firstDate = date1 ? new Date(date1) : new Date();
    const secondDate = date2 ? new Date(date2) : new Date();

    // Calculate the difference in milliseconds
    const differenceInMilliseconds = secondDate - firstDate;

    // Convert milliseconds to days
    const differenceInDays =
      Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

    return differenceInDays;
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <button
        className="w-full flex items-center justify-between px-6 py-4 bg-gradient-to-r from-gray-50 to-white hover:from-gray-100 hover:to-gray-50 transition-all duration-200 group"
        onClick={toggleCollapse}
        aria-expanded={!isCollapsed}
        aria-controls="collapseIdleHistory"
      >
        <div className="flex items-center space-x-3">
          <div className={`transform transition-transform duration-200 ${isCollapsed ? "" : "rotate-180"}`}>
            <HiOutlineChevronDown className="w-5 h-5 text-gray-600" />
          </div>
          <span className="text-sm font-bold text-gray-800 uppercase tracking-wide">
            IDLE HISTORY
          </span>
        </div>
        <span className="text-xs text-gray-500 uppercase tracking-wider font-medium">
          {isCollapsed ? "Click to Expand" : "Click to Collapse"}
        </span>
      </button>
      <div
        className={`transition-all duration-300 ease-in-out ${
          isCollapsed ? "max-h-0 opacity-0" : "max-h-[5000px] opacity-100"
        } overflow-hidden`}
        id="collapseIdleHistory"
      >
        <div className="p-6 bg-white">
          <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  {titles.map((columnName, index) => (
                    <th
                      key={index}
                      scope="col"
                      className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                    >
                      {columnName}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {idleHistory && idleHistory.length > 0 ? (
                  idleHistory.map((listItem, index) => {
                    // Calculate IDLE DAYS based on position
                    let idleDays = null;

                    if (index === 0) {
                      // First row: mobilization_date - arrival_date 
                      if (data?.data?.[0]?.arrival_date && listItem.mobilization_date) {
                        idleDays = getDaysBetweenDates(
                          data.data[0].arrival_date,
                          listItem.mobilization_date
                        );
                      }
                    } else {
                      // 2nd row onwards: current_row.mobilization_date -previous_row.demobilization_date
                      const previousRow = idleHistory[index - 1];
                      if (previousRow?.demobilization_date && listItem.mobilization_date) {
                        idleDays = getDaysBetweenDates(
                          previousRow.demobilization_date,
                          listItem.mobilization_date
                        );
                      }
                    }

                    return (
                      <tr key={index} className="hover:bg-gray-50 transition-colors duration-150">
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {index + 1}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.client_name || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.project_name || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.basic || "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {(() => {
                            const total =
                              (parseFloat(listItem.basic) || 0) +
                              (parseFloat(listItem.food) || 0) +
                              (parseFloat(listItem.fixed_ot) || 0) +
                              (parseFloat(listItem.hra) || 0) +
                              (parseFloat(listItem.travel_allowance) || 0) +
                              (parseFloat(listItem.mobile_allowance) || 0) +
                              (parseFloat(listItem.air_ticket_allowance) || 0) +
                              (parseFloat(listItem.additional_ot) || 0) +
                              (parseFloat(listItem.other_allowance) || 0);
                            return total > 0 ? total.toFixed(2) : "-";
                          })()}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.mobilization_date
                            ? new Date(listItem.mobilization_date)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .split(" ")
                                .join("-")
                                .toUpperCase()
                            : "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.demobilization_date
                            ? new Date(listItem.demobilization_date)
                                .toLocaleDateString("en-GB", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                                .split(" ")
                                .join("-")
                                .toUpperCase()
                            : "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-semibold text-gray-900">
                          {idleDays !== null ? idleDays : "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.demobilization_date && listItem.mobilization_date
                            ? getDaysBetweenDates(
                                listItem.mobilization_date,
                                listItem.demobilization_date
                              )
                            : "-"}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                          {listItem.demobilization_date && listItem.mobilization_date
                            ? getDaysBetweenDates(
                                listItem.mobilization_date,
                                listItem.demobilization_date
                              )
                            : "-"}
                        </td>
                        <td className="px-6 py-4 text-sm text-gray-900 max-w-xs">
                          {index === 0
                            ? "1ST IDLE DURATION"
                            : (listItem.remarks || listItem.demobilization_comments || "REST IDLE DURATION")}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={titles.length}
                      className="px-6 py-8 text-center text-sm text-gray-500"
                    >
                      No idle history records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
